import { useMutation, useQueryClient } from 'react-query';

import { updateFormAgreement } from '@app/store/transport-layer/form/terms';

export default function useAgreeFormTerms() {
  const queryClient = useQueryClient();

  return useMutation<{ formUseAgreed: boolean }, Error>(
    () => updateFormAgreement({ formUseAgreed: true }),
    {
      onSuccess: (data) => {
        queryClient.setQueryData('form/useFormTerms', data);
      },
    }
  );
}
